import { Switch } from '../../../Switch'
import { Control } from '../Control'

function ControlBoolean({ value, onChange, ...controlProps }) {
  function handleChange(nextValue) {
    onChange(value, { value: nextValue })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <Switch
        disabled={value.omitted}
        value={value.value ?? false}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlBoolean
